/**
 * getInitials — İsimden baş harf kısaltması üretir
 *
 * "Ayşe Yılmaz" → "AY"
 * "Ali"         → "A"
 * ""            → "?"
 *
 * @param {string} name
 * @returns {string}
 */
export function getInitials(name) {
  if (!name) return '?';
  const parts = String(name).trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}
